Hideaways.frozen = function () {
    var frozen = new AccountFrozen();
    frozen.init();

    Hideaways._frozen = frozen;
}
